<div
  class="logo-container"
  [class.small]="size === 'small'"
  [class.medium]="size === 'medium'"
  [class.large]="size === 'large'"
>
  <div class="cool-text-logo">
    <span class="logo-exam">exam</span><span class="logo-ally">Ally</span>
  </div>
  <div class="logo-tagline" *ngIf="showTagline">Your Ally in Certification Success</div>
</div>
